import React from 'react';
import './CartDesignOptions.scss';
import returnIcon from "../Assets/returnIcon.svg";
import deliveryIcon from '../Assets/delivery.svg';
import rupeesIcon from "../Assets/rupeesIcon.svg";
import selectSvg from '../Assets/select.svg';

// Hardcoded product data for design showcase
const sampleProduct = {
  brand: "Puma",
  title: "Classic White T-Shirt",
  seller: "Puma Sports India Pvt. Ltd.(NSCM)",
  price: 599,
  mrp: 799,
  discount: 25,
  size: "M",
  qty: 1,
  image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&h=500&fit=crop" // Placeholder
};

export function CartDesignOptions() {
  return (
    <div className="cart-design-options">
      <h2 className="options-title">Mobile Cart Item Design Options</h2>
      
      {/* Option 1: Stacked Layout - Image on Top */}
      <div className="design-option">
        <h3 className="option-label">Option 1: Stacked Layout (Image on Top)</h3>
        <div className="option-description">
          Full-width image on top, all details below. Best for showcasing product image.
        </div>
        <div className="cart-item-option-1">
          <div className="item-image-section">
            <div className="selection-checkbox">
              <img src={selectSvg} alt="Selected" />
            </div>
            <img src={sampleProduct.image} alt={sampleProduct.title} className="product-image" />
          </div>
          
          <div className="item-details-section">
            <div className="brand-name">{sampleProduct.brand}</div>
            <div className="product-name">{sampleProduct.title}</div>
            <div className="seller-info">Sold by: {sampleProduct.seller}</div>
            
            <div className="price-section">
              <div className="current-price">
                <img src={rupeesIcon} alt="₹" />
                {sampleProduct.price}
              </div>
              <div className="price-info">
                <span className="mrp">₹{sampleProduct.mrp}</span>
                <span className="discount">{sampleProduct.discount}% OFF</span>
              </div>
            </div>
            
            <div className="controls-section">
              <div className="control-item">
                <span className="control-label">Size:</span>
                <div className="control-select green">M</div>
              </div>
              <div className="control-item">
                <span className="control-label">Qty:</span>
                <div className="control-select green">1</div>
              </div>
            </div>
            
            <div className="info-section">
              <div className="info-item">
                <img src={returnIcon} alt="Return" />
                <span>14 days return available</span>
              </div>
              <div className="info-item">
                <img src={deliveryIcon} alt="Delivery" />
                <span>Delivery in <strong>2 days</strong></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Option 2: Compact Horizontal - Smaller Image */}
      <div className="design-option">
        <h3 className="option-label">Option 2: Compact Horizontal (Smaller Image)</h3>
        <div className="option-description">
          Smaller image (80px), optimized content layout. Better space utilization.
        </div>
        <div className="cart-item-option-2">
          <div className="item-image-compact">
            <div className="selection-checkbox-small">
              <img src={selectSvg} alt="Selected" />
            </div>
            <img src={sampleProduct.image} alt={sampleProduct.title} />
          </div>
          
          <div className="item-content-compact">
            <div className="content-header">
              <div>
                <div className="brand-compact">{sampleProduct.brand}</div>
                <div className="product-compact">{sampleProduct.title}</div>
              </div>
            </div>
            
            <div className="seller-compact">Sold by: {sampleProduct.seller}</div>
            
            <div className="price-compact">
              <span className="price-main">₹{sampleProduct.price}</span>
              <span className="price-old">₹{sampleProduct.mrp}</span>
              <span className="price-off">{sampleProduct.discount}% OFF</span>
            </div>
            
            <div className="controls-compact">
              <div className="control-compact">
                <span>Size:</span>
                <div className="select-compact green">M</div>
              </div>
              <div className="control-compact">
                <span>Qty:</span>
                <div className="select-compact green">1</div>
              </div>
            </div>
            
            <div className="info-compact">
              <span>14 days return</span>
              <span>•</span>
              <span>Delivery in 2 days</span>
            </div>
          </div>
        </div>
      </div>

      {/* Option 3: Minimal Horizontal - Very Compact */}
      <div className="design-option">
        <h3 className="option-label">Option 3: Minimal Horizontal (Very Compact)</h3>
        <div className="option-description">
          Smallest image (70px), condensed details. Maximum space efficiency.
        </div>
        <div className="cart-item-option-3">
          <div className="item-image-minimal">
            <div className="selection-checkbox-minimal">
              <img src={selectSvg} alt="Selected" />
            </div>
            <img src={sampleProduct.image} alt={sampleProduct.title} />
          </div>
          
          <div className="item-content-minimal">
            <div className="header-minimal">
              <div>
                <div className="brand-minimal">{sampleProduct.brand}</div>
                <div className="product-minimal">{sampleProduct.title}</div>
              </div>
            </div>
            
            <div className="price-minimal">
              <span className="price-main-minimal">₹{sampleProduct.price}</span>
              <span className="price-old-minimal">₹{sampleProduct.mrp}</span>
              <span className="price-off-minimal">{sampleProduct.discount}% OFF</span>
            </div>
            
            <div className="controls-minimal">
              <div className="select-minimal green">Size: M</div>
              <div className="select-minimal green">Qty: 1</div>
            </div>
            
            <div className="info-minimal">
              <span>14d return</span>
              <span>•</span>
              <span>2d delivery</span>
            </div>
          </div>
        </div>
      </div>

      {/* Option 4: Card with Image Background */}
      <div className="design-option">
        <h3 className="option-label">Option 4: Card with Image Background</h3>
        <div className="option-description">
          Image as background with overlay content. Modern, visually striking.
        </div>
        <div className="cart-item-option-4">
          <div className="image-background" style={{ backgroundImage: `url(${sampleProduct.image})` }}>
            <div className="overlay-content">
              <div className="selection-checkbox-overlay">
                <img src={selectSvg} alt="Selected" />
              </div>
              
              <div className="content-overlay">
                <div className="brand-overlay">{sampleProduct.brand}</div>
                <div className="product-overlay">{sampleProduct.title}</div>
                
                <div className="price-overlay">
                  <span className="price-main-overlay">₹{sampleProduct.price}</span>
                  <span className="price-old-overlay">₹{sampleProduct.mrp}</span>
                  <span className="price-off-overlay">{sampleProduct.discount}% OFF</span>
                </div>
                
                <div className="controls-overlay">
                  <div className="select-overlay green">Size: M</div>
                  <div className="select-overlay green">Qty: 1</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}





